import { CSSProperties } from 'react';

import { closeDropdownFromElementWithin } from 'components/Dropdown/closeDropdownFromElementWithin';
import { Icon } from 'components/Icon/Icon';
import { IconName } from 'components/Icon/IconName';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { getStaticImageSrc } from 'utils/getImageSrc';

import {
  DropdownFoldMenuButtonLink,
  DropdownFoldMenuHolder,
  DropdownFoldMenuPanel,
  DropdownFoldMenuPanelButtonLinksHolder,
  DropdownFoldMenuPanelTitle,
  DropdownFoldMenuRichContentHolder,
  DropdownFoldMenuRichLink,
  DropdownFoldMenuRichLinkDescription,
  DropdownFoldMenuRichLinkImageHolder,
  DropdownFoldMenuRichLinkTitle,
  DropdownFoldMenuRichLinksHolder,
  DropdownMobileBackdrop,
  dropdownFoldMenuColumnsCountVar,
} from './DropdownFoldMenu.styled';

type Props = {
  left: {
    title: string;
    items: Array<{
      iconName: IconName;
      title: string;
      href: string;
      qaId: string;
      trackClicked: { name: string; context: string };
    }>;
  };
  right:
    | {
        title: string;
        items: Array<{
          image: string;
          title: string;
          description: string;
          href: string;
          qaId: string;
          trackClicked: { name: string; context: string };
        }>;
      }
    | undefined;
};

export function DropdownFoldMenu({ left, right }: Props) {
  return (
    <DropdownFoldMenuHolder>
      <DropdownFoldMenuPanel>
        <DropdownFoldMenuPanelTitle>{left.title}</DropdownFoldMenuPanelTitle>

        <DropdownFoldMenuPanelButtonLinksHolder
          style={
            {
              [dropdownFoldMenuColumnsCountVar]: Math.ceil(
                left.items.length / 3,
              ),
            } as CSSProperties
          }
        >
          {left.items.map((item) => (
            <DropdownFoldMenuButtonLink
              key={item.title}
              to={item.href}
              data-qa-id={item.qaId}
              onClick={(event) => {
                trackClicked(item.trackClicked.name, {
                  context: item.trackClicked.context,
                });
                closeDropdownFromElementWithin(event.target as HTMLElement);
              }}
            >
              <Icon name={item.iconName} size={16} />
              <span>{item.title}</span>
            </DropdownFoldMenuButtonLink>
          ))}
        </DropdownFoldMenuPanelButtonLinksHolder>
      </DropdownFoldMenuPanel>

      {right && (
        <DropdownFoldMenuPanel>
          <DropdownFoldMenuPanelTitle>{right.title}</DropdownFoldMenuPanelTitle>

          <DropdownFoldMenuRichLinksHolder>
            {right.items.map((item) => (
              <DropdownFoldMenuRichLink
                key={item.title}
                to={item.href}
                data-qa-id={item.qaId}
                onClick={(event) => {
                  trackClicked(item.trackClicked.name, {
                    context: item.trackClicked.context,
                  });

                  closeDropdownFromElementWithin(event.target as HTMLElement);
                }}
              >
                <DropdownFoldMenuRichLinkImageHolder>
                  <img
                    src={getStaticImageSrc(item.image)}
                    alt=""
                    style={{ width: 40 }}
                    loading="lazy"
                  />
                </DropdownFoldMenuRichLinkImageHolder>

                <DropdownFoldMenuRichContentHolder>
                  <DropdownFoldMenuRichLinkTitle>
                    {item.title}
                  </DropdownFoldMenuRichLinkTitle>

                  <DropdownFoldMenuRichLinkDescription>
                    {item.description}
                  </DropdownFoldMenuRichLinkDescription>
                </DropdownFoldMenuRichContentHolder>
              </DropdownFoldMenuRichLink>
            ))}
          </DropdownFoldMenuRichLinksHolder>
        </DropdownFoldMenuPanel>
      )}

      <DropdownMobileBackdrop
        onClick={(event) =>
          closeDropdownFromElementWithin(event.target as HTMLElement)
        }
      />
    </DropdownFoldMenuHolder>
  );
}
